import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { getWalletTransactions } from "../../../../api/walletTransaction";

const DepositTable = () => {
  const rowsPerPage = 10;
  const [activePage, setActivePage] = useState(1);
  const [depositData, setDepositData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDepositTransactions = async () => {
      setLoading(true);
      try {
        const response = await getWalletTransactions({
          page: activePage,
          limit: rowsPerPage,
          type: "buy", // Important: type is "buy" for deposits
        });
        console.log("response buy", response.data)
        setDepositData(response.data.data || []);
        setTotalCount(response.data.total || 0);
        setError(null);
      } catch (err) {
        setError("Failed to fetch deposit transactions");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchDepositTransactions();
  }, [activePage]);

  const totalPages = Math.ceil(totalCount / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setActivePage(page);
    }
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const items = [];
    const visiblePages = 5;

    let startPage = Math.max(1, activePage - Math.floor(visiblePages / 2));
    let endPage = startPage + visiblePages - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - visiblePages + 1);
    }

    if (startPage > 1) {
      items.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        items.push(
          <span key="start-ellipsis" className="px-2 text-primary">
            ...
          </span>
        );
      }
    }

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === activePage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        items.push(
          <span key="end-ellipsis" className="px-2 text-primary">
            ...
          </span>
        );
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return (
      <Pagination className="mt-4 pagination-gutter pagination-primary no-bg">
        <li className="page-item page-indicator">
          <a
            href="#!"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(activePage - 1);
            }}
            aria-disabled={activePage === 1}
          >
            <i className="la la-angle-left" />
          </a>
        </li>
        {items}
        <li className="page-item page-indicator">
          <a
            href="#!"
            className="page-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(activePage + 1);
            }}
            aria-disabled={activePage === totalPages}
          >
            <i className="la la-angle-right" />
          </a>
        </li>
      </Pagination>
    );
  };

  if (loading) return <p>Loading deposit transactions...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="table-responsive dataTablehistory">
      <div id="depositdata_wrapper" className="dataTables_wrapper no-footer">
        <table
          className="table dataTable shadow-hover display"
          style={{ minWidth: "845px" }}
        >
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              {/* <th>Status</th> */}
            </tr>
          </thead>
          <tbody>
            {console.log("deposit table", depositData)}
            {depositData.length > 0 ? (
              depositData.map((item, index) => {
                const date = item.createdAt
                  ? new Date(item.createdAt).toLocaleString()
                  : "N/A";

                const amount = Number(
                   item.quantity || 0
                ).toFixed(2);
                const status = item.status || "No status found";

                return (
                  <tr key={item.id || index}>
                    <td>{date}</td>
                    <td>{amount}</td>
                    {/* <td>{status}</td> */}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={4} className="text-center">
                  No deposit records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="d-flex justify-content-center w-100 mt-3 mb-3">
          {renderPagination()}
        </div>
      </div>
    </div>
  );
};

export default DepositTable;
